import { defineMessage } from 'services/localization';

export const messages = {
    disconnectionWarningText: defineMessage('the_matrix_is_not_avail_ed_from_integrationname'),
};
